import {ListContentChangeRequest} from './list-content-change-request';

export default ListContentChangeRequest;